import React, { useState, useEffect } from 'react';
import { MatrixQuestion } from '../../survey-tools/likert-scales';
import { shuffleArray } from '../../survey-tools/shuffle-and-sample'; // Import shuffleArray
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import { Typography} from "@mui/material";
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function CesdDepression({ instanceId,nextTask }) {
    const [showDialog, setShowDialog] = useState(false);
    const [shuffledStatements, setShuffledStatements] = useState([]);
    const [responses, setResponses] = useState(Array(20).fill(-99)); 

    useEffect(() => {
        const statements = [
        "I was bothered by things that usually don't bother me.",
        "I did not feel like eating; my appetite was poor.",
        "I felt that I could not shake off the blues even with help from my family or friends.",
        "I felt that I was just as good as other people.",
        "I had trouble keeping my mind on what I was doing.",
        "I felt depressed.",
        "I felt that everything I did was an effort.",
        "I felt hopeful about the future.",
        "I thought my life had been a failure.",
        "I felt fearful.",
        "My sleep was restless.",
        "I was happy.",
        "I talked less than usual.",
        "I felt lonely.",
        "People were unfriendly.",
        "I enjoyed life.",
        "I had crying spells.",
        "I felt sad.",
        "I felt that people disliked me.",
        "I could not get 'going.'"
    ];
        setShuffledStatements(shuffleArray(statements));
    }, [])


    const options = ["Rarely", "Some of the time", "Occasionally", "Most of the time"];

    const statementKeyMap = {
    "I was bothered by things that usually don't bother me.": "cesd_1",
    "I did not feel like eating; my appetite was poor.": "cesd_2",
    "I felt that I could not shake off the blues even with help from my family or friends.": "cesd_3",
    "I felt that I was just as good as other people.": "cesd_4",
    "I had trouble keeping my mind on what I was doing.": "cesd_5",
    "I felt depressed.": "cesd_6",
    "I felt that everything I did was an effort.": "cesd_7",
    "I felt hopeful about the future.": "cesd_8",
    "I thought my life had been a failure.": "cesd_9",
    "I felt fearful.": "cesd_10",
    "My sleep was restless.": "cesd_11",
    "I was happy.": "cesd_12",
    "I talked less than usual.": "cesd_13",
    "I felt lonely.": "cesd_14",
    "People were unfriendly.": "cesd_15",
    "I enjoyed life.": "cesd_16",
    "I had crying spells.": "cesd_17",
    "I felt sad.": "cesd_18",
    "I felt that people disliked me.": "cesd_19",
    "I could not get 'going.'": "cesd_20"
};

    const handleNextClick = () => {
        const isComplete = responses.every(val => val !== -99);
            if (!isComplete) {
                setShowDialog(true); // Show confirmation dialog if not complete
            } else {
                const cesdRatings = {};
                shuffledStatements.forEach((statement, index) => {
                    const key = statementKeyMap[statement];

                    cesdRatings[key] = responses[index];
                });

                nextTask({ data: { cesd: cesdRatings } });
                console.log(cesdRatings)
            }
        }

    return (
        <PageContainer>

        <div>
            <MatrixQuestion
            title={<>
            <Typography gutterBottom>Below is a list of feelings and experiences you might have sometimes. Please rate how often you have felt this way during the past two weeks.</Typography>
            <Typography>During the past two weeks...</Typography></>}
                rows={shuffledStatements}
                columns={options}
                handleUpdate={(data) => setResponses(data)}
            />
                                    <div style={{ height: '20px' }}></div> 

            <Button variant="contained" onClick={handleNextClick}>Next</Button>

            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    const cesdRatings = {};
                shuffledStatements.forEach((statement, index) => {
                    const key = statementKeyMap[statement];

                    cesdRatings[key] = responses[index];
                });

                nextTask({ data: { cesd: cesdRatings } });
                console.log(cesdRatings)
                }}
            />

        </div>
        </PageContainer>
 
    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(CesdDepression);

